// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"e016c20d","249":"f0354c42","320":"3ea1a391","446":"3b34b1dc"}[chunkId] + ".chunk.js";
};